exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".shared_checkbox .v-label {\n  color: black;\n}", ""]);

// exports
